import type {ReactAction} from '@netx/core/bootstrap';
import {faStar} from '@fortawesome/pro-solid-svg-icons';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionToggleFavoriteIcon = faStar;

/**
 * Saved cart toggle favorite
 * @param params
 * @returns Action
 */
export const cartSavedActionToggleFavorite = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-toggle-favorite',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.TOGGLE_FAVORITE, savedCart),
	icon: cartSavedActionToggleFavoriteIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.TOGGLE_FAVORITE;
	},
	...params,
});

export default cartSavedActionToggleFavorite;
